export default () => {
  // let newsControls = document.querySelectorAll(".js-newsFilterControls");
  let newsItems = document.querySelectorAll(".js-newsFilterCards");
  let newsControls = document.querySelectorAll(".js-list-item");
  let showAllBtn = document.querySelector(".js-showAllBtn");

  newsControls.forEach((item) => {
    item.classList.remove("hidden");
    item.addEventListener("click", function (e) {
      e.preventDefault();

      let controlId = this.dataset.id;

      newsControls.forEach((c) => {
        if (c.dataset.id != controlId) {
          c.classList.add("hidden");
        }
      });

      showAllBtn.classList.add("show");
      showAllBtn.addEventListener("click", function (e) {
        e.preventDefault();
        newsControls.forEach((c) => {
          c.classList.remove("hidden");
        });
        newsItems.forEach((item) => {
          item.classList.remove("hidden");
        });

        this.classList.remove("show");
      });

      newsItems.forEach((item) => {
        item.classList.toggle(
          "hidden",
          !(item.dataset.id.indexOf(controlId) > -1)
        );
      });
    });
  });
};
